import { render, staticRenderFns } from "./PaginationUni.vue?vue&type=template&id=a6fd419e&scoped=true"
import script from "./PaginationUni.vue?vue&type=script&lang=js"
export * from "./PaginationUni.vue?vue&type=script&lang=js"
import style0 from "./PaginationUni.vue?vue&type=style&index=0&id=a6fd419e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fd419e",
  null
  
)

export default component.exports